import { Injectable, Signal, signal, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of } from 'rxjs';
import { catchError, filter, map, retry, tap } from 'rxjs/operators';
import { MeGQL } from 'src/app/shared/graphql/generated/account-link.graphql';
import { AuthenticatedUser } from 'src/app/shared/graphql/model/account-link/me-query.model';
import { GLOBAL_TOASTER_KEY } from 'src/app/shared/models';

@Injectable({ providedIn: 'root' })
export class UserService {
  private meGQL = inject(MeGQL);
  private snackBar = inject(MatSnackBar);

  private _me = signal<AuthenticatedUser | null>(null);
  public me: Signal<AuthenticatedUser | null> = this._me.asReadonly();

  subscribeToMe() {
    let retryCount = 0;
    this.meGQL
      .watch()
      .valueChanges.pipe(
        retry({ count: 5, delay: retryCount++ * 100 }),
        catchError(() => {
          this.snackBar.open(
            'Error loading user profile. Refresh or contact app support...',
            'close',
            { duration: 5000, panelClass: 'error' }
          );
          return of(null);
        }),
        filter(Boolean),
        map((response) => response.data?.me),
        filter((me): me is AuthenticatedUser => Boolean(me)),
        tap((me: AuthenticatedUser) => {
          this._me.set(Object.freeze(me));
        })
      )
      .subscribe();
  }
}
